export const TEAMMATE_PRESENCE_FF = 'cc_onboarding_teammate_presence';

export const TEAMMATE_PRESENCE_GATE = 'cc_onboarding_teammate_presence_gate';

export enum CONTENT_MODE_STATUS {
	VIEW = 'view',
	EDIT = 'edit',
}
